import type { constants as WalletConstants } from 'modules/Wallet';

export enum View {
  Accept = 'accept',
  Reject = 'reject'
}

export type DepositLimitIntervalsInURL = Lowercase<WalletConstants.DepositLimitIntervalsInPayload>;
